
import { useId } from '~/utils/useId'

export default {
  props: {},

  data() {
    return {
      coupon: '',
      id: `redeem-coupon-${useId()}`,
    }
  },

  methods: {
    async submitForm() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      this.$router.push({
        path: '/coupons/redeem',
        query: {
          coupon: this.coupon,
        },
      })
    },
  },
}
